﻿<script setup lang='ts'>
    const emits = defineEmits([
        'onCancel'
    ]);
    const onClose = () => emits('onCancel');

</script>

<template>
    <b-modal
        has-modal-card
        model-value
        @close="onClose">
        <div
            ref="modalContent"
            class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <slot name="modal-header" />
                </p>
            </header>
            <section
                class="modal-body modal-card-body">
                <div>
                    <slot name="modal-body" />
                </div>
            </section>
        </div>
    </b-modal>
</template>

<style scoped>
.modal-card {
    width: 900px;
    max-width: 90vw;
}

.modal-body {
    padding: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

</style>
